import { AppCustomizerService } from 'src/providers/app-customizer-service/app-customizer.service';
import { PushNotificationService } from 'src/providers/pushnotification-service/pushnotification-service';
import { LiveUpdateService } from 'src/providers/live-update-service/live-update.service';
import { initializeApp } from 'firebase/app';
import { Dialogs } from '@awesome-cordova-plugins/dialogs/ngx';
import { TranslationService } from 'src/i18n/translation-service';
import { AfterViewInit, Component, NgZone, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Storage } from '@ionic/storage-angular';
import {
  MenuController,
  NavController,
  Platform,
  ToastController,
  IonicModule,
  ModalController,
  AlertController,
} from '@ionic/angular';
import { SignInPage } from './pages/sign-in/sign-in.page';
import { Observable, Subscription } from 'rxjs';
import {
  ClubInfo,
  PlayerHomeInfo,
  PlayerInfo,
  createClubInfo,
  ClubDataLite,
} from 'src/data/mygolf.data';
// import { StatusBar } from '@ionic-native/status-bar/ngx';
// import { Network } from '@ionic-native/network/ngx';
// import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { SplashScreen as splashScreen } from '@capacitor/splash-screen';

// Add these imports instead
import { StatusBar, Style } from '@capacitor/status-bar';
// import { SplashScreen } from '@capacitor/splash-screen';

import { App } from 'ionic';
import { PlayerHomeActions, PlayerHomeDataService } from 'src/redux/player-home';
import { SessionActions, SessionDataService } from 'src/redux/session';
import { ServerInfoService } from 'src/providers/serverinfo-service/serverinfo-service';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { ServerInfo } from 'src/data/server-info';
import { filter, map, take } from 'rxjs/operators';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { setChartDefaults } from 'src/charts/chart-globals';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import * as global from '../globals';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { CurrentUser, SessionInfo } from 'src/data/authentication-info';
import {
  SUBSCRIBE_EWALLET_TOPUP,
  SUBSCRIBE_EWALLET_TRANSACTION,
  WebsocketActions,
} from 'src/redux/wstomp';
import { NavigationEnd, NavigationExtras, NavigationStart, Router } from '@angular/router';
import { App as CapacitorApp } from '@capacitor/app';
import { register } from 'swiper/element/bundle';

import * as moment from 'moment';
import { PermissionsService } from 'src/providers/permission-service';
import { DynamicImportService } from 'src/providers/dynamic-import-scss/dynamic-import-scss';

import { Network } from '@capacitor/network';
import { ConnectionService } from 'src/providers/connection-service/connection-service';

import { PushNotifications } from '@capacitor/push-notifications';
import OneSignal from 'onesignal-cordova-plugin';

import { SafeArea } from 'capacitor-plugin-safe-area';

// Firebase Web SDK disabled for iOS compatibility
// import { getToken, onMessage, getMessaging } from 'firebase/messaging';
// import { messaging } from 'src/main';
import { environment } from 'src/environments/environment';
import { MyGolfStorageService } from 'src/storage/mygolf-storage.service';
import disableDevtool from 'disable-devtool';
import { CapacitorUpdater } from '@capgo/capacitor-updater';
import { CapacitorHttp, PluginListenerHandle } from '@capacitor/core';
import { CommonPullupMenuComponent } from './pages/modal-screens/common-pullup-menu/common-pullup-menu.component';
import { compare } from 'semver';
import { AccountOptionPage } from './pages/modal-screens/account-option/account-option.page';

// import { OneSignal } from '@awesome-cordova-plugins/onesignal/ngx';
register();

declare var window: any;
// declare const OneSignal: any;

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class MyApp implements AfterViewInit {
  @ViewChild(NavController) nav: NavController;
  labels = {};

  // make HelloIonicPage the root (or first) page
  rootPage: any = SignInPage;
  pages: Array<{ title: string; component: any }>;

  private disconnectSubscriber: Subscription;
  // private connectSubscriner: Subscription;

  public playerHomeInfo$: Observable<PlayerHomeInfo>;
  public player$: Observable<PlayerInfo>;

  showLogin: boolean;
  loggedIn = false;

  isBookingRegistrationEnabled: boolean;
  clubSpecificThemes;

  ewalletTopupSub: Subscription;
  ewalletTrxnSub: Subscription;
  spinnerLoaderDelay = 5000;

  // Track if Capacitor Updater has been initialized
  // Defer initialization until appAttributes are loaded from server
  private capUpdaterInitialized = false;

  // Storage keys for update tracking
  private readonly UPDATE_LAST_CHECK_KEY = 'update_last_check_timestamp';
  private readonly UPDATE_LAST_VERSION_KEY = 'update_last_applied_version';

  _register: any;
  _compRegister: any;
  constructor(
    public platform: Platform,
    private Location: Location,
    public menu: MenuController,
    public toastCtl: ToastController,
    // public statusBar: StatusBar,
    // public network: Network,
    // public dialogs: Dialogs,
    private dialogs: Dialogs,
    // public splashScreen: SplashScreen,
    //  public app1: IonApp,
    // public _ionicApp: IonicApp,
    public playerHomeService: PlayerHomeDataService,
    private sessionDataService: SessionDataService,
    private serverInfoService: ServerInfoService,
    private flightService: ClubFlightService,
    private translate: TranslateService,
    private translationCustomService: TranslationService,
    private mg2uUtil: mygolfUtils,
    private websocketActions: WebsocketActions,
    private playerHomeActions: PlayerHomeActions,
    private router: Router,
    private mg2uUtils: mygolfUtils,
    private modalCtl: ModalController,
    private alertCtrl: AlertController,
    private permissionsService: PermissionsService,
    private dynamicImportService: DynamicImportService,
    private networkService: ConnectionService,
    private storage: MyGolfStorageService,
    private pushNotfService: PushNotificationService,
    private sessionActions: SessionActions,
    private zone: NgZone,
    private liveUpdateService: LiveUpdateService,
    private customizerService: AppCustomizerService
  ) {
    this.setupConnectionHandlers();
    this.handleAllowedMessageDisplay();

    // initiateCapUpdater() will be called after appAttributes are loaded
    // in onPageChange() to ensure data is available
    // This prevents undefined values for tenant and updateVersion

    // this.initCheckPermissions();
    const _consoleParam = this.platform.getQueryParam('showConsole');

    if (this.platform.getQueryParam('spinnerLoaderDelay')) {
      this.spinnerLoaderDelay = Number(this.platform.getQueryParam('spinnerLoaderDelay'));
    }
    if (global.environment && global.environment.includes('prod') && !_consoleParam) {
      console.warn(`? There is nothing to look at here`);
      console.log = function (): void {};
      console.debug = function (): void {};
      console.warn = function (): void {};
      console.info = function (): void {};
    }

    const _devToolParam = this.platform.getQueryParam('inspectorHere');
    if (global.environment.includes('prod') && !_devToolParam) {
      disableDevtool({
        // optional: callback when it detects DevTools
        disableInputSelect: true,
        disableSelect: true,
        disableMenu: true,
        disableCopy: true,
        disableCut: true,
        ondevtoolopen: (type: any) => {
          this.zone.run(() => {
            MessageDisplayUtil.showErrorToast(
              'This app does not support DevTools',
              this.platform,
              this.toastCtl,
              5000,
              'bottom'
            );
            this.sessionActions.logout();
          });
          // console.warn('DevTools opened, type:', type);
          // e.g., redirect or block UI
          // window.location.href = '/';
        },
        // you can add other config options here
      });
    }

    this._register = this.platform.getQueryParam('register');
    this._compRegister = this.platform.getQueryParam('compRegister');
    this.initializeApp();

    this.mg2uUtils.getWebParams();
    this.setInitLanguage(this.translationCustomService.getLanguage());
    // enablePlayerAppBooking
    this.serverInfoService.serverInfo().subscribe((data: ServerInfo) => {
      if (data) {
        this.isBookingRegistrationEnabled = data.enablePlayerAppBooking;
      }
    });

    platform.ready().then(() => {
      this.setupSafeArea();
      if (this.platform.is('capacitor')) {
        // Request permission to use push notifications
        // this.OneSignalInit();
        PushNotifications.requestPermissions().then(result => {
          if (result.receive === 'granted') {
            // Initialize OneSignal
            this.OneSignalInit();
          }
        });
      } else {
        // this.OneSignalInit();
        // this.setupWebOneSignal();
      }

      this.getAppAttribute();
      this.getAppRoleAccess();
      this.websocketActions.configure();
      // Do your thing...
      if (!this.platform.is('capacitor')) {
        this.setupBackButtonBehavior();
      } else {
        this.initializeBackButton();
      }

      // this.getHomeAttribute();
    });

    // set our app's pages
    this.pages = [];
    this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();
    this.player$ = this.playerHomeInfo$.pipe(
      filter(Boolean),
      map((playerHome: PlayerHomeInfo) => playerHome.player)
    );
    let _playerId = null;

    const _param = Number(this.platform.getQueryParam('param'));

    if (_param) {
      this.mg2uUtil.setClubSpecific(true);
      this.mg2uUtil.setClubId(_param);
      this.customizerService.setClubWebParam(_param);
      this.flightService.getClubInfo(_param).subscribe((data: ClubDataLite) => {
        this.mg2uUtil.setSelectedClub(data);
        this.mg2uUtil.setClubParam(true);
        // this.nav.setRoot(PlayerHomePage,{
        //     useParam: true
        // })
      });
    } else {
      this.customizerService.setClubWebParam(0);
    }

    this.sessionDataService
      .getSession()
      .pipe(take(1))
      .subscribe(
        (session: SessionInfo) => {
          if (session && session.password) {
          } else {
          }
        },
        error => {}
      );

    this.ewalletTopupSub = this.websocketActions
      .subscribeTo(SUBSCRIBE_EWALLET_TOPUP)
      .subscribe((data: any) => {
        this.player$.pipe(take(1)).subscribe(player => {
          _playerId = player.playerId;
        });
        if (data && data.playerId === _playerId) {
          this.getEwalletMessage(data, 'topup');
        }
      });

    this.ewalletTrxnSub = this.websocketActions
      .subscribeTo(SUBSCRIBE_EWALLET_TRANSACTION)
      .subscribe((data: any) => {
        this.player$.pipe(take(1)).subscribe(player => {
          _playerId = player.playerId;
        });

        if (data && data.playerId === _playerId) {
          this.getEwalletMessage(data, 'transaction');
        }
        // if(data && data.clubId === )
      });
    // this.initializeBackButton();
  }

  ngAfterViewInit() {
    const splashScreen = document.getElementById('custom-splash-screen');
    setTimeout(() => {
      if (splashScreen) {
        splashScreen.style.display = 'none';
      }
    }, this.spinnerLoaderDelay);

    this.platform.ready().then(() => {
      this.loadURLParams();
      // Firebase Web SDK disabled for iOS compatibility
      // this.initWebFirebase();
    });
  }

  public pageRoleAccess: Array<any>;
  getAppRoleAccess() {
    this.flightService.getAppRoleAccess().subscribe((data: any) => {
      if (data) {
        this.pageRoleAccess = data;
      }
    });
  }

  OneSignalInit(): void {
    const appId = '5f98a462-4a70-4cac-848a-0771f37c7178'; //'8a23eb44-fcac-4899-a4e4-2ce8fbd9851a';
    // 8a23eb44-fcac-4899-a4e4-2ce8fbd9851a

    // if (
    //   (this.platform.is('capacitor') || this.platform.is('cordova')) &&
    //   window.plugins &&
    //   window.plugins.OneSignal
    // ) {
    //   try {
    //     // For OneSignal Cordova plugin
    //     // Replace with your actual OneSignal App ID
    //     // window.plugins.OneSignal.setAppId(appId);

    //     // Enable debug logs (optional)
    //     window.plugins.OneSignal.setLogLevel(6, 0);

    //     // Handle notification opening
    //     window.plugins.OneSignal.setNotificationOpenedHandler(jsonData => {
    //       console.log('OneSignal: notification opened:', jsonData);
    //       // Handle notification click
    //     });

    //     // Handle notification received while app is in foreground
    //     window.plugins.OneSignal.setNotificationWillShowInForegroundHandler(jsonData => {
    //       console.log('OneSignal: notification received in foreground:', jsonData);
    //       // Return true to show the notification, or false to suppress it
    //       return true;
    //     });

    //     // Get the player ID (device token)
    //     window.plugins.OneSignal.getDeviceState(deviceState => {
    //       console.log('OneSignal Device State:', deviceState);
    //       console.log('Player ID:', deviceState.userId);
    //     });

    //     // Request push notification permission (iOS)
    //     // This is handled automatically by OneSignal on Android
    //     window.plugins.OneSignal.promptForPushNotificationsWithUserResponse(accepted => {
    //       console.log('User accepted notifications:', accepted);
    //     });

    //     console.log('OneSignal initialized successfully');
    //   } catch (error) {
    //     console.error('Error initializing OneSignal:', error);
    //   }
    // } else {
    //   console.log('OneSignal plugin not available');
    // }

    // // OneSignal Initialization for Mobile
    // this.oneSignal.startInit(appId);

    // // Optional: Configure notification received handler
    // this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.Notification);

    // // Notification Open Handler
    // this.oneSignal.handleNotificationOpened().subscribe(jsonData => {
    //   console.log('Notification opened:', jsonData);
    //   // Handle notification opening logic
    // });

    // // Notification Received Handler
    // this.oneSignal.handleNotificationReceived().subscribe(jsonData => {
    //   console.log('Notification received:', jsonData);
    //   // Handle notification received logic
    // });

    // // Get OneSignal User ID
    // this.oneSignal.getIds().then(ids => {
    //   console.log('OneSignal User ID:', ids.userId);
    //   // Send this ID to your backend if needed
    // });

    // this.oneSignal.initialize(appId);
    // // Finish initialization
    // this.oneSignal.endInit();

    // Uncomment to set OneSignal device logging to VERBOSE
    // OneSignal.setLogLevel(6, 0);
    // NOTE: Update the setAppId value below with your OneSignal AppId.
    // OneSignal.setAppId(appId);
    // OneSignal.setNotificationOpenedHandler(function(jsonData) {
    // });
    // // Prompts the user for notification permissions.
    // //    * Since this shows a generic native prompt, we recommend instead using an In-App Message to prompt for notification permission (See step 7) to better communicate to your users what notifications they will get.
    // OneSignal.promptForPushNotificationsWithUserResponse(function(accepted) {
    // });

    // Enable verbose logging for debugging (remove in production)
    OneSignal.Debug.setLogLevel(6);
    // Initialize with your OneSignal App ID
    OneSignal.initialize(appId);
    // console.debug('one signal init', appId);
    // Use this method to prompt for push notifications.
    // We recommend removing this method after testing and instead use In-App Messages to prompt for notification permission.
    OneSignal.Notifications.requestPermission(false).then((accepted: boolean) => {
      console.log('User accepted notifications: ' + accepted);
    });

    this.player$.pipe(take(1)).subscribe(player => {
      // _playerId = player.playerId;
      OneSignal.User.addTags({
        playerId: player.playerId,
      });
    });
    // // Make sure OneSignal is available
    // if (window.plugins && window.plugins.OneSignal) {
    //   window.plugins.OneSignal.setAppId(appId);
    //   // 8a23eb44-fcac-4899-a4e4-2ce8fbd9851a

    //   // Handle notification opening
    //   window.plugins.OneSignal.setNotificationOpenedHandler(jsonData => {
    //     console.log('Notification opened:', jsonData);
    //     // Handle your notification open logic here
    //   });

    //   // Handle notification received while app is in foreground
    //   window.plugins.OneSignal.setNotificationWillShowInForegroundHandler(jsonData => {
    //     console.log('Notification received in foreground:', jsonData);
    //     // Return true to show the notification, or false to suppress it
    //     return true;
    //   });

    //   // Get the player ID (device token)
    //   window.plugins.OneSignal.getDeviceState(deviceState => {
    //     console.log('OneSignal Device State:', deviceState);
    //     console.log('Player ID:', deviceState.userId);
    //   });
    // }

    // NOTIFICATION HANDLERS

    // 1. When a notification is received while app is in foreground
    OneSignal.Notifications.addEventListener('foregroundWillDisplay', event => {
      console.log('OneSignal: NOTIFICATION WILL DISPLAY:', JSON.stringify(event));
      console.table(event);

      const notification = event.getNotification();
      console.log('notification: ', notification);

      // Get custom data from the notification
      const data = notification.additionalData;
      console.log('Additional data: ', data);

      // You can either:

      // Option 1: Display the notification
      // event.complete(notification);

      // Option 2: Prevent display but handle it yourself
      // event.complete(null);

      // Parse and handle the notification data here
      // this.handleNotificationData(notification);
    });

    // 2. When a notification is tapped by the user
    OneSignal.Notifications.addEventListener('click', event => {
      console.log('OneSignal: NOTIFICATION CLICKED:', event);

      // const notification = event.getNotification();
      // const actionId = event.getActionId();

      // console.log('Launch URL: ', notification.launchURL);
      // console.log('Action ID: ', actionId);

      // // Get custom data from the notification
      // const data = notification.additionalData;
      // console.log('Additional data: ', data);

      // // Parse and handle the notification click
      // this.handleNotificationClick(notification, actionId);
    });

    // 3. Get information about the device and subscription
    // OneSignal.User.addEmailSubscriptionObserver(event => {
    //   console.log('OneSignal: Email subscription changed: ', event);
    // });

    // OneSignal.User.addSmsSubscriptionObserver(event => {
    //   console.log('OneSignal: SMS subscription changed: ', event);
    // });

    // OneSignal.User.addPushSubscriptionObserver(event => {
    //   console.log('OneSignal: Push subscription changed: ', event);
    // });

    // Get the OneSignal User ID (formerly player ID) and other device info
    // this.getOneSignalUserID();
  }

  // Get the user ID when it's available
  getOneSignalUserID() {
    OneSignal.User.getOnesignalId().then(id => {
      console.log('OneSignal User ID: ', id);
      // You can send this ID to your server to target this user with notifications
    });

    // Get the push subscription details
    // OneSignal.User.getPushSubscription().then(subscription => {
    //   console.log('Push subscription: ', subscription);
    //   console.log('Push subscription ID: ', subscription.id);
    //   console.log('Push subscription token: ', subscription.token);
    //   console.log('Push subscription enabled: ', subscription.optedIn);
    // });
  }

  // Handle notification data processing
  handleNotificationData(notification: any) {
    // Example notification data parsing
    const notificationData = notification.additionalData;

    if (notificationData) {
      // Handle specific notification types
      if (notificationData.type === 'message') {
        // Handle a message notification
        console.log('Message from: ', notificationData.sender);
        console.log('Message content: ', notificationData.message);

        // You might want to navigate to a chat screen or display a modal
        // this.navigateToChat(notificationData.senderId);
      } else if (notificationData.type === 'order') {
        // Handle an order notification
        console.log('Order update: ', notificationData.orderStatus);
        console.log('Order ID: ', notificationData.orderId);

        // Maybe navigate to order details
        // this.navigateToOrderDetails(notificationData.orderId);
      } else {
        // Handle generic notifications
        console.log('Generic notification data: ', notificationData);
      }
    }
  }

  // Handle notification click
  handleNotificationClick(notification: any, actionId: string | null) {
    const notificationData = notification.additionalData;

    // Check if there's a specific action ID (from action buttons)
    if (actionId) {
      switch (actionId) {
        case 'accept_action':
          console.log('User accepted the request');
          // Handle acceptance logic
          break;
        case 'decline_action':
          console.log('User declined the request');
          // Handle decline logic
          break;
        default:
          console.log('Unknown action: ', actionId);
      }
    }

    // Handle navigation based on notification data
    if (notificationData && notificationData.route) {
      // Navigate to the specified route in your app
      console.log('Navigating to: ', notificationData.route);
      // this.router.navigateByUrl(notificationData.route);
    }

    // Handle deep links if present
    if (notification.launchURL) {
      console.log('Launch URL: ', notification.launchURL);
      // Handle deep link - could open in-app browser or navigate
      // window.open(notification.launchURL, '_system');
    }
  }

  checkName() {
    // let activePortal = this.nav.getActive();
    // let _msg = activePortal.component.name;
    const _msg = '';
    MessageDisplayUtil.showMessageToast(_msg, this.platform, this.toastCtl, 3000, 'bottom');
  }

  private setupBackButtonBehavior() {
    console.debug('set up back button ');
    this.backButtonSubscription = this.platform.backButton.subscribeWithPriority(
      10000,
      async () => {
        const modal = await this.modalCtl.getTop();
        console.debug('set up back button ', modal);
        if (modal) {
          modal.dismiss();
          // If a modal is open, prevent default back button behavior
          return;
        }

        // Your existing back button logic for non-modal cases
        // const currentUrl = this.router.url;
        // if (currentUrl === '/home') {
        //   // Handle exit confirmation
        //   // this.showExitConfirmation();
        // } else {
        this.Location.back();
        // }
      }
    );

    // // Handle popstate for browser back button
    // // window.history.pushState(null, '', window.location.href);
    window.onpopstate = async () => {
      const modal = await this.modalCtl.getTop();
      if (modal) {
        console.debug('modal ', modal);
        modal.dismiss();
        // If a modal is open, prevent navigation
        // window.history.pushState(null, '', window.location.href);
        return;
      }

      //   // Your existing popstate logic for non-modal cases
      //   // ...
    };
    // If on web version (browser)
    // if (window.location.protocol !== "file:") {

    //   // Register browser back button action(s)
    //   window.onpopstate = (evt) => {

    //     // Close menu if open
    //     if (this.menu.isOpen()) {
    //       this.menu.close();
    //       return;
    //     }

    //     // Close any active modals or overlays
    //     //comment
    //     // let activePortal = this._ionicApp._loadingPortal.getActive() ||
    //     //   this._ionicApp._modalPortal.getActive() ||
    //     //   this._ionicApp._toastPortal.getActive() ||
    //     //   this._ionicApp._overlayPortal.getActive();

    //     // if (activePortal) {
    //     //   activePortal.dismiss();
    //     //   return;
    //     // }

    //     // Navigate back
    //     // if (this.app.getRootNav().canGoBack()) this.app.getRootNav().pop();

    //   };

    //   // // Fake browser history on each view enter
    //   // this.app.viewDidEnter.subscribe((app) => {
    //   //   history.pushState(null, null, "");
    //   // });

    // }
  }

  private getEwalletMessage(data, type) {
    let _action = '';
    let _msg = '';
    let _clubName = '';
    let _currency = '';
    let _amount = 0;

    switch (type) {
      case 'topup':
        if (data.action === 'topUp') {
          _action = 'Added New Top Up';
        } else if (data.action === 'topUpUpdate') {
          _action = 'Updated Top Up';
        } else if (data.action === 'topUpDelete') {
          _action = 'Deleted Top Up';
        }
        _amount = this.mg2uUtil.numberWithCommas(data.amount);
        // if(data.amount) _amount = data.amount;

        this.getClubInfo(data.clubId)
          .then((result: any) => {
            if (result.status === 'success') {
              _clubName = result.clubInfo.clubTag;
              _currency = result.clubInfo.country.currencySymbol;
              _msg =
                data.topUpByName +
                ' from ' +
                _clubName +
                ' has successfully ' +
                _action +
                ' for amount of ' +
                _currency +
                ' ' +
                _amount;

              this.playerHomeActions.setNeedRefresh(true);
              this.playerHomeActions.refreshHomeInfo();
              MessageDisplayUtil.showMessageToast(
                _msg,
                this.platform,
                this.toastCtl,
                15000,
                'bottom'
              );
            }
          })
          .catch(error => {
            _msg = 'Succesfully ' + data.action + ' for amount of ' + _amount;
            MessageDisplayUtil.showMessageToast(_msg, this.platform, this.toastCtl, 5000, 'bottom');
          });
        break;
      case 'transaction':
        let _expType = 'Miscellaneous';
        let _outletName = '';
        let _trxnDate = '';

        let _totalAmount = 0;

        if (data.action === 'transactions') {
          _action = 'deducted';
        } else if (data.action === 'undoTransaction') {
          _action = 'Undo a Transaction';
        }

        const _trxnDetails = [];
        _trxnDetails.push(...data.transactions);
        this.getClubInfo(data.clubId)
          .then((result: any) => {
            if (result.status === 'success') {
              _clubName = result.clubInfo.clubTag;
              _currency = result.clubInfo.country.currencySymbol;

              if (data.action === 'transactions') {
                _expType = _trxnDetails[0].expenditureType;
                _outletName = _trxnDetails[0].outletName;
                _trxnDate = _trxnDetails[0].transactionDate;
                _totalAmount = _trxnDetails.map(trxn => trxn.amount).reduce((a, b) => a + b, 0);
              } else if (data.action === 'undoTransaction') {
                _totalAmount = data.amount;
                _expType = data.expenditureType;
                _outletName = data.outletName;
                _trxnDate = data.transactionDate;
              }
              _totalAmount = this.mg2uUtil.numberWithCommas(_totalAmount);

              _msg =
                '[' +
                _outletName +
                ' - ' +
                _expType +
                '] ' +
                _trxnDate +
                ' - Successfully ' +
                _action +
                ' amount of ' +
                _currency +
                ' ' +
                _totalAmount;
              // _msg = data.topUpByName + ' from ' + _clubName + ' has successfully ' + _action + ' for amount of '+ _currency+ ' ' + _amount;
              // _msg = "Successfully "+_action+ " amount of "+_currency+' '+ _totalAmount + " for "+_outletName + " on "+_trxnDate;

              this.playerHomeActions.setNeedRefresh(true);
              this.playerHomeActions.refreshHomeInfo();
              MessageDisplayUtil.showMessageToast(
                _msg,
                this.platform,
                this.toastCtl,
                15000,
                'bottom'
              );
            }
          })
          .catch(error => {
            // _msg = 'Succesfully ' + _action + ' for amount of ' + _amount;
            // MessageDisplayUtil.showMessageToast(_msg,
            //     this.platform, this.toastCtl, 5000, "bottom");
          });
        break;
    }
  }

  clubInfo: any;
  getClubInfo(clubId: number) {
    return new Promise((resolve, reject) => {
      if (!clubId) {
        reject({
          status: 'failed',
          message: 'No Club Id provided',
        });
      } else if (clubId) {
        this.flightService.getClubInfo(clubId).subscribe((data: ClubInfo) => {
          if (data) {
            resolve({
              status: 'success',
              message: 'club info',
              clubInfo: data,
            });
          }
        });
      }
    });
  }
  loadDynamicStylesheet() {
    const url = `${global.MygolfServer}/document/assets/themes.css`;
    this.dynamicImportService.loadStylesheet(url);

    if (global.appClient?.length) {
      if (global.appClient === 'EPSL') {
        document.body.className = 'theme-' + 'epsl';
      } else if (global.appClient === 'WAGC-QLFR') {
        document.body.className = 'theme-' + 'wagc-qlfr';
      } else if (global.appClient === 'WAGC') {
        document.body.className = 'theme-' + 'wagc';
      } else {
        document.body.className = '';
      }
    }
  }
  initializeApp() {
    this.loadDynamicStylesheet();
    this.platform.ready().then(async () => {
      // Check for live updates after platform is ready
      // await this.liveUpdateService.checkAndApplyUpdate();
      // await this.liveUpdateService.newTestDownload();
      this.initCheckPermissions();
      if (!this.mg2uUtils.getPref('communalMode')) {
        this.mg2uUtils.setPref('communalMode', true);
      }

      // Handle app state changes
      CapacitorApp.addListener('appStateChange', ({ isActive }) => {
        if (isActive) {
          // App has come to foreground
          this.handleAppResume();
        } else {
          // App has gone to background
          this.handleAppPause();
        }
      });

      history.pushState(null, '');
      //     let _register = this.platform.getQueryParam('register');
      //     let _compRegister = this.platform.getQueryParam('compRegister');
      //     if (_register && _register === 'true') {
      //       this.sessionDataService.showLoginForm().subscribe((show: boolean) => {
      //         this.showLogin = show;

      //         if (show) {
      //           this.sessionDataService.getCurrentUser()
      //             .subscribe((currUser: CurrentUser) => {
      //               // this.username.setValue(currUser.userName);
      //             });
      //             this.router.navigate(['sign-up']);
      //         } else {

      //         }

      //       });
      //       // this.nav.setRoot(SignUp, {
      //       //   useParam: true
      //       // })
      //       // this.mg2uUtil.goToHome();
      //       // this.nav.popToRoot();
      //       return;
      //     }

      //     if(!!_compRegister && Number(_compRegister) > 0) {

      //       this.sessionDataService.showLoginForm().subscribe((show: boolean) => {
      //         this.showLogin = show;

      //         if (show) {
      //           this.sessionDataService.getCurrentUser()
      //             .subscribe((currUser: CurrentUser) => {
      //             });
      //             this.router.navigate(['sign-up']);
      //         } else {
      //           this.getCompetitionData(Number(_compRegister))
      //           .then((result: any)=>{
      //             console.debug("get comp data", Number(_compRegister), result);
      //             let navigationExtras: NavigationExtras = {
      //               state: {
      //                 competition: result,
      //                 compId: result?.id,
      //                 animate: false,
      //               },
      //             };
      //             this.router.navigate(['competition-details'], navigationExtras);
      //           }).catch((error)=>{
      //             if(error === true) {
      //                 MessageDisplayUtil.showErrorToast("There is no competition with this id",
      //                 this.platform, this.toastCtl, 3000, 'bottom');
      //             } else {
      //               let _message = 'There is no competition with this id';
      //               if(error?.errorMessage) _message = error?.errorMessage;
      //               MessageDisplayUtil.showErrorToast(_message,
      //               this.platform, this.toastCtl, 3000, 'bottom');
      //             }
      //           })
      //         }

      //       });
      //     }
      setChartDefaults();
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.

      try {
        await StatusBar.setStyle({ style: Style.Light });
        await StatusBar.show();
        if (this.platform.is('android')) {
          await StatusBar.setOverlaysWebView({ overlay: true });
        } else {
          await StatusBar.setOverlaysWebView({ overlay: false });
        }
        // await StatusBar.setBackgroundColor({ color: '#000000' });
        // await StatusBar.setBackgroundColor({ color: '#71be72' });

        // this.statusBar.styleDefault();
        // this.statusBar.show();
        // this.statusBar.overlaysWebView(false);
        // this.statusBar.backgroundColorByHexString('#71be72');
      } catch (error) {}

      // this.statusBar.overlaysWebView(true);
      // StatusBar.hide();
      this.hideSplashScreen();
      // this.platform.backButton.subscribeWithPriority(101, () => {

      //comment navigate to previosu page or exit app
      // let nav = this.app.getRootNav();
      // let activeNav = this.app.getActiveNav();
      // if (nav === activeNav && nav.getActive() && nav.getActive().isFirst())
      //   this.confirmAndExit(nav);
      // else
      //   this.app.navPop();

      // });
      // CapacitorApp.addListener('backButton', ({ canGoBack }) => {
      //     window.history.back();
      //   // console.log('on back button', canGoBack);
      //   // if (!canGoBack) {
      //   //   CapacitorApp.exitApp();
      //   // } else {
      //   //   window.history.back();
      //   // }
      // });
      // this.platform.backButton.subscribeWithPriority(0, (processNextHandler) => {
      //   // this.Location.back();
      //   console.log("on back button - platorm" );
      //   console.log("on back button - platorm", this.router.getCurrentNavigation().extractedUrl);

      // });

      // this.disconnectSubscriber = this.network.onDisconnect()
      //   .subscribe(() => {
      //     MessageDisplayUtil.showErrorToast("You have lost your data connection.",
      //       this.platform, this.toastCtl, 3000, 'bottom');

      //   });

      if (global.appType === 'club' && global.clubId === 310510386) {
        this.updateColor('gold');
      } else {
        this.updateColor(null, true);
      }
    });

    this.platform.ready().then(() => {
      // CapacitorApp.addListener('backButton', ({canGoBack}) => {
      //   if(!canGoBack){
      //     CapacitorApp.exitApp();
      //   } else {
      //     window.history.back();
      //   }
      // });
      // document.addEventListener('backbutton', () => {
      //   console.log("on back button - document " )
      //   //
      //   //  if (this.navCtrl.canGoBack()) {
      //   //    this.platform.exitApp()
      //   //    return;
      //   //  }
      //   //  this.navCtrl.pop()
      // }, false);
    });

    // this.sessionDataService.showLoginForm().subscribe((show: boolean) => {
    //     this.showLogin = show;
    //     if (show) {
    //         // this.sessionDataService.getCurrentUser()
    //         //     .subscribe((currUser: CurrentUser) => {
    //         //         this.username.setValue(currUser.userName);
    //         //     });
    //     }

    // });

    this.sessionDataService.getSessionStatus().subscribe((data: any) => {
      //
      if (data === 1) {
        this.loggedIn = true;
      } else if (data === 3) {
        this.loggedIn = false;
      } else {
        this.loggedIn = false;
      }
    });

    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(event => {
      this.onPageChange(event);
    });
  }

  openPage(page) {
    // close the menu when clicking a link from the menu
    this.menu.close();

    // navigate to the new page if it is not the current page
    // this.nav.push(page.component);
  }

  confirmAndExit(nav: NavController) {
    if (this.platform.is('capacitor')) {
      //

      this.dialogs
        .confirm('Do you want to exit myGolf2u ?', 'Exit App', ['No', 'Exit'])
        .then((result: any) => {
          if (result && result === 2) {
            // this.platform.exitApp();
            navigator['app'].exitApp();
          }
        });
    }
  }

  hideSplashScreen() {
    // if (splashScreen) {
    setTimeout(() => {
      splashScreen.hide();
    }, 1000);
    // }
  }

  onHomeClick() {
    if (this.disableFooterPage(3)) {
      return false;
    }
    //
    // this.nav.popToRoot();//this.nav.setRoot(PlayerHomePage);
  }

  openProfile() {
    if (this.disableFooterPage(5)) {
      return false;
    }
    // this.nav.push(ProfilePage, {
    //   type: 'playerProfile',
    //   player: this.player$
    // });
    const params: NavigationExtras = {
      replaceUrl: false,
      state: {
        type: 'playerProfile',
        player: this.player$,
      },
    };
    this.router.navigate(['tabs/profile'], params);
  }

  onMyBookingsClick() {
    // console.debug("on my bookings click")
    if (this.disableFooterPage(1)) {
      return false;
    }
    if (!this.isBookingRegistrationEnabled) {
      MessageDisplayUtil.showErrorToast(
        'Booking & Registration feature will be coming soon.',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }

    // if(this.fromClub) this.nav.push(BookingCalendarPage , {clubId: _clubId})
    // else this.nav.push(BookingHomePage);
    // this.nav.push(BookingHomePage);

    let _isClubSpecific = false;
    let _club: ClubInfo;
    _club = createClubInfo();
    if (global.appType === 'club' && global.clubId) {
      _isClubSpecific = true;
      this.mg2uUtil.setClubSpecific(true);
      // _club['clubId'] = global.clubId
      this.flightService.getClubInfo(global.clubId).subscribe((club: ClubInfo) => {
        if (club) {
          _club = club;
          const params: NavigationExtras = {
            replaceUrl: false,
            state: {
              userType: 'player',
              isClubSpecific: _isClubSpecific,
              club: _club,
              clubSpecificThemes: this.clubSpecificThemes,
            },
          };
          // this.router.navigate(['booking-home'], params);
          this.router.navigate(['find-tee-times'], params);
        }
      });
    } else {
      if (this.mg2uUtil.getSelectedClub()) {
        this.mg2uUtil.setClubSpecific(true);
      } else {
        this.mg2uUtil.setClubSpecific(false);
      }
      const params: NavigationExtras = {
        replaceUrl: false,
        state: {
          userType: 'player',
          isClubSpecific: _isClubSpecific,
          club: this.mg2uUtil.getSelectedClub() ? this.mg2uUtil.getSelectedClub() : _club,
          clubSpecificThemes: this.clubSpecificThemes,
        },
      };
      // this.router.navigate(['booking-home'], params);
      this.router.navigate(['find-tee-times'], params);
    }
  }

  onFAQClick() {
    if (this.disableFooterPage(4)) {
      return false;
    }
    if (global.appType === 'club' && global.clubId) {
      return false;
    }
    this.router.navigate(['tabs/faq']);
  }

  onNotificationsClick() {
    if (this.disableFooterPage(2)) {
      return false;
    }
    if (this.appAttribute && !this.appAttribute.enableNotfPage && global.appType === 'club') {
      let _msg = 'This feature will be coming soon.';
      if (this.appAttribute && !this.appAttribute.errorNotfMessage) {
        _msg = this.appAttribute.errorNotfMessage;
      }
      MessageDisplayUtil.showErrorToast(_msg, this.platform, this.toastCtl, 3000, 'bottom');
      return;
    }
    this.router.navigate(['tabs/notifications']);
  }

  showFooterPage() {
    enum pageToExclude {
      'SetupPlayingCoursesPage',
      'FlightSetupPage',
      'CompetitionPlayersPage',
      'PlayerMg2uCreditsModal', //n4-4
      'RefundBookingPlayersModal',
      'CaddyScheduleDisplayPage',
      'ClubBookingListPage',
      'BookingCalendarPage',
    }

    const _showFooter = true;

    //commnet
    // let viewAll = this.nav.getAllChildNavs();
    // let activePortal = this.nav.getActive();
    // let name = activePortal.component.name;
    // let activeView = this.nav.getActive();

    //  if (activeView && activeView.instance && activeView.instance.appFooterHide) _showFooter = false;

    // this.nav.viewDidEnter.subscribe(item => {
    //   const viewController = item as ViewController;
    //   const n = viewController.name;
    //   name = viewController.name;
    //   const id = viewController.id;
    // });

    // for (let value in pageToExclude) {
    //   if (name.toLowerCase().includes(value.toLowerCase())) {
    //     _showFooter = false;
    //     continue;
    //   }
    // }

    return _showFooter;
  }

  disableFooterPage(type?: number) {
    let _disableFooter = false;
    // //comment
    // // let activePortal = this.nav.getActive();
    // // let name = activePortal.component.name;
    // const name = '';
    // if (type === 1) {
    //   //mybookings
    //   if (name === 'BookingHomePage') {
    //     _disableFooter = true;
    //   }
    // } else if (type === 2) {
    //   //notifications
    //   if (name === 'NotificationsPage') {
    //     _disableFooter = true;
    //   }
    //   // NotificationsPage
    // } else if (type === 3) {
    //   //home
    //   if (name === 'PlayerHomePage') {
    //     _disableFooter = true;
    //   }
    //   // BookingHomePage
    // } else if (type === 4) {
    //   //FAQ
    //   if (name === 'FaqPage') {
    //     _disableFooter = true;
    //   }
    //   // FaqPage
    // } else if (type === 5) {
    //   //profile
    //   if (name === 'ProfilePage') {
    //     _disableFooter = true;
    //   }
    // }
    return _disableFooter;
  }

  appAttribute: any;
  showConsoleLog = false;
  getAppAttribute() {
    this.flightService.getAppAttributes().subscribe(
      (data: any) => {
        if (data) {
          data
            .filter(d => d.page === 'mainApp')
            .map(d => {
              this.appAttribute = d;
            });

          data
            .filter(theme => theme.page === 'playerHome')
            .map(theme => {
              this.clubSpecificThemes = theme.clubSpecificThemes;
              if (theme && theme.clubSpecificThemes) {
                theme.clubSpecificThemes.filter(club => {
                  if (global.appType === 'club' && global.clubId === club.clubId) {
                    this.updateColor(club.themeName);
                  }
                });
              }
            });
          if (this.appAttribute) {
            if (this.appAttribute.showConsoleLog) {
              this.showConsoleLog = this.appAttribute.showConsoleLog;
            }
          }
        }
      },
      error => {},
      () => {
        if (!this.showConsoleLog) {
        }
      }
    );
  }

  setInitLanguage(lang) {
    //
    this.translate.currentLang = lang;
    this.translationCustomService.changeLanguage(lang);
    this.translate
      .get([
        'USER_NOT_LOGGED_IN',
        'LOGOUT_TITLE',
        'LOGOUT_DESCRIPTION',
        'YES',
        'NO',
        'EXIT_APPLICATION',
        'EXIT_CONFIRMATION',
      ])
      .subscribe(res => {
        for (const key in res) {
          this.labels[key] = res[key];
        }
      });
  }

  updatedColor = 0;

  getSVGImageClass(additionalClass: string) {
    if (this.updatedColor > 0) {
      return additionalClass + ' ' + 'svg-filter';
    } else {
      return additionalClass;
    }
  }

  updateColor(themeName?: string, reset?: boolean) {
    // document.documentElement.style.setProperty(`--color`, color);

    if (global.appClient === 'WAGC-QLFR') {
      document.body.className = 'theme-' + 'wagc-qlfr';
      return;
    }
    if (themeName) {
      document.body.className = 'theme-' + themeName;
    } else {
      document.body.className = '';
    }
    // .toggle(color);
    // document.documentElement.style.setProperty(`--ion-border-color`, color);
  }

  backButtonSubscription: Subscription;
  ngOnDestroy() {
    if (this.backButtonSubscription) {
      this.backButtonSubscription.unsubscribe();
    }
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
    this.doneShowMaintenance = false;
    Network.removeAllListeners();
    this.websocketActions.closeConnection();
  }

  getHomeAttribute() {
    return new Promise((resolve, reject) => {
      let _appAttribute;
      this.flightService.getAppAttributes().subscribe((data: any) => {
        if (data) {
          this.mg2uUtil.setAppAttributes(data);
          data
            .filter(d => d.page === 'playerHome')
            .map(d => {
              _appAttribute = d;
            });

          if (_appAttribute) {
            resolve({
              appAttribute: _appAttribute,
              maintenance: _appAttribute.maintenance,
              announcement: _appAttribute.announcement,
            });
            // // let _maintenance = this.appAttribute.maintenance;
            // if (_appAttribute.maintenance) {
            //   resolve({
            //     appAttribute: _appAttribute,
            //     maintenance: _appAttribute.maintenance
            //   })
            //   // this.displayMaintenance(_appAttribute);
            // }
            // // let _announcement = this.appAttribute.annoucement;
            // if (_appAttribute.announcement) {
            //   resolve({
            //     appAttribute: _appAttribute,
            //     announcement: _appAttribute.announcement
            //   })
            //   // this.displayAnnouncement(this.appAttribute);
            // }
          }
        }
      });
    });
  }

  doneShowMaintenance = false;
  async displayMaintenance(appAttribute) {
    if (this.doneShowMaintenance) {
      return;
    }
    if (!appAttribute) {
      return false;
    }
    const _maintenance = appAttribute.maintenance;
    const _fromDate = _maintenance.fromDate;
    const _daysBefore = _maintenance.daysBefore;
    let _dateBefore;
    if (_daysBefore) {
      _dateBefore = moment(_fromDate).add(-1 * _daysBefore, 'days');
    }
    const _toDate = _maintenance.toDate;
    // if(_daysBefore) _dateBefore = moment(_toDate).add(-1*_daysBefore, "days");
    const _fromTime = _maintenance.fromTime;
    const _toTime = _maintenance.toTime;

    const _fromDateTime = moment(_fromDate + _fromTime, 'YYYY-MM-DDHH:mm');
    // moment(_dateBefore).format("YYYY-MM-DD")

    const _toDateTime = moment(_toDate + _toTime, 'YYYY-MM-DDHH:mm');
    if (_maintenance.showMaintenanceMessage) {
      this.doneShowMaintenance = true;
      // let _msg = "Server is currently under maintenance. <br>Scheduled time <br><b>"+moment(_fromDateTime).format("ddd, DD MMM YYYY HH:mm") + "</b> to <b>" + moment(_toDateTime).format("ddd, DD MMM YYYY HH:mm")+"</b>";
      let _msg =
        'The system will be unavailable during the following period : <br><b>' +
        moment(_fromDateTime).format('ddd, DD MMM YYYY HH:mm') +
        '</b> to <br><b>' +
        moment(_toDateTime).format('ddd, DD MMM YYYY HH:mm') +
        '</b>';
      if (_maintenance.maintenanceMessage) {
        _msg =
          _maintenance.maintenanceMessage +
          '<br><b>' +
          moment(_fromDateTime).format('ddd, DD MMM YYYY HH:mm') +
          '</b> to <br><b>' +
          moment(_toDateTime).format('ddd, DD MMM YYYY HH:mm') +
          '</b>';
      }
      const _buttons = [];
      if (
        _maintenance.blockForMaintenance &&
        moment().isBetween(_fromDateTime, _toDateTime, 'minute')
      ) {
        if (this.platform.is('capacitor')) {
          _buttons.push({
            text: 'Close',
            role: 'cancel',
            handler: () => {
              if (this.platform.is('capacitor')) {
                _alert.dismiss(true);
              }
              return false;
            },
          });
        }
      } else {
        _buttons.push({
          text: 'Okay',
          role: 'cancel',
          handler: () => {
            _alert.dismiss(false);
            return false;
          },
        });
      }
      const _alert = await this.alertCtrl.create({
        header: 'Server Maintenance',
        message: _msg,
        buttons: _buttons,
        backdropDismiss: _maintenance.blockForMaintenance ? false : true,
      });
      _alert.onDidDismiss().then((exit: any) => {
        if (exit) {
          this.platform.pause;
        }
      });
      // if(moment().isBetween(_fromDate + " " + _fromTime, _toDate + " " + _toTime ))

      // if(moment().isBetween(_fromDateTime, _toDateTime,'minute') ||  moment().isBetween(_dateBefore,moment(_toDate,"YYYY-MM-DD")))
      if (moment().isBetween(_dateBefore, _toDateTime, 'minute')) {
        _alert.present();
      }
      // .endOf('day')
    } else {
      this.doneShowMaintenance = false;
    }
  }

  onPageChange(event) {
    // Example: Log page change
    // console.log('Page changed [0]',event);
    this.getHomeAttribute().then((result: any) => {
      // Initialize Capacitor Updater after appAttributes are loaded
      // This ensures getSpecificAppAttributePage('mainApp') returns valid data
      if (this.platform.is('capacitor') && !this.capUpdaterInitialized) {
        this.capUpdaterInitialized = true;
        this.initiateCapUpdater();
      }

      // console.log('Page changed [1]', this.doneShowMaintenance, this.doneShowAnnouncement);
      // console.log('Page changed [2]', result);
      if (result?.maintenance) {
        this.displayMaintenance(result.appAttribute);
      }
      if (result?.announcement) {
        if (event?.url.includes('player-home') || event?.url.includes('/sign-in')) {
          this.displayAnnouncement(result.appAttribute);
        }
      }
    });
    // Add any other code you need to execute on each page change
  }

  doneShowAnnouncement = false;
  async displayAnnouncement(appAttribute) {
    console.debug('display announcement - player home', appAttribute);
    if (this.doneShowAnnouncement) {
      return;
    }
    if (!appAttribute) {
      return;
    }
    if (appAttribute?.announcement?.preV5only) {
      return;
    }
    const _announcement = appAttribute.announcement;
    const _fromDate = moment(_announcement.fromDate, 'YYYY-MM-DD');
    const _toDate = moment(_announcement.toDate, 'YYYY-MM-DD');

    if (_announcement.showAnnouncement) {
      this.doneShowAnnouncement = true;
      let _msg = 'Welcome to myGolf2u';
      if (_announcement.announcementMessage) {
        _msg = _announcement.announcementMessage;
      }
      const _buttons = [];
      _buttons.push({
        text: 'Okay',
        role: 'cancel',
        handler: () => {
          _alert.dismiss(false);
          return false;
        },
      });
      const _alert = await this.alertCtrl.create({
        header: 'Announcement',
        message: _msg,
        buttons: _buttons,
      });
      _alert.onDidDismiss().then(exit => {
        if (exit) {
          this.platform.pause;
        }
      });
      if (moment().isBetween(_fromDate, _toDate, 'day', '[]')) {
        _alert.present();
      }
    } else {
      this.doneShowAnnouncement = false;
    }
  }

  getCompetitionData(compId: number) {
    return new Promise((resolve, reject) => {
      if (!compId) {
        reject(true);
      }
      this.flightService.getCompetitionDetails(compId).subscribe(
        compData => {
          resolve(compData);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  loadURLParams() {
    if (this._register && this._register === 'true') {
      this.sessionDataService.showLoginForm().subscribe((show: boolean) => {
        this.showLogin = show;

        if (show) {
          this.sessionDataService.getCurrentUser().subscribe((currUser: CurrentUser) => {});
          this.router.navigate(['sign-up']);
        } else {
        }
      });
      return;
    }

    if (!!this._compRegister && Number(this._compRegister) > 0) {
      this.sessionDataService
        .getSession()
        .pipe(take(1))
        .subscribe(
          (session: SessionInfo) => {
            if (session && session.userId) {
              this.getCompetitionData(Number(this._compRegister))
                .then((result: any) => {
                  // console.debug("get comp data", Number(this._compRegister), result);
                  const navigationExtras: NavigationExtras = {
                    state: {
                      competition: result,
                      compId: result?.id,
                      animate: false,
                    },
                  };
                  this.router.navigate(['competition-details'], navigationExtras);
                })
                .catch(error => {
                  if (error === true) {
                    MessageDisplayUtil.showErrorToast(
                      'There is no competition with this id',
                      this.platform,
                      this.toastCtl,
                      3000,
                      'bottom'
                    );
                  } else {
                    let _message = 'There is no competition with this id';
                    if (error?.errorMessage) {
                      _message = error?.errorMessage;
                    }
                    MessageDisplayUtil.showErrorToast(
                      _message,
                      this.platform,
                      this.toastCtl,
                      3000,
                      'bottom'
                    );
                  }
                });
            } else {
              this.sessionDataService.getCurrentUser().subscribe((currUser: CurrentUser) => {});
              this.router.navigate(['sign-up']);
              return;
            }
          },
          error => {
            this.sessionDataService.getCurrentUser().subscribe((currUser: CurrentUser) => {});
            this.router.navigate(['sign-up']);
            return;
          }
        );
    }
  }

  removeUrlParam(paramToRemove: string) {
    const currentUrl = this.router.url;
    const urlTree = this.router.parseUrl(currentUrl);

    // Remove specific query parameter
    delete urlTree.queryParams[paramToRemove];

    // Navigate without triggering a route change
    this.router.navigateByUrl(urlTree);
  }

  private handleAppResume() {
    // this.websocketActions.configure();
    setTimeout(() => {
      this.simulateTouchAtCenter();
    }, 750); // Add a small delay to ensure the app is fully visible
    // Get the current URL
    const currentUrl = this.router.url;

    // // Force a refresh of the current route
    // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
    //   this.router.navigate([currentUrl]);
    // });

    // // Optional: Refresh any data that might be stale
    // this.refreshAppData();
  }

  private handleAppPause() {
    // Save any necessary app state here
    // For example: save form data to localStorage
    // this.saveAppState();
  }

  networkStatus: boolean;
  isConnected: boolean;
  private networkSubscription: Subscription;
  async ngOnInit() {
    // Get initial status
    this.isConnected = this.networkService.getCurrentNetworkStatus();

    // Subscribe to changes
    this.networkSubscription = this.networkService.onNetworkStatusChange().subscribe(connected => {
      console.debug('app comp - network status change', connected);
      this.isConnected = connected;
      this.handleNetworkChange(connected);
    });

    // // Get the current network status
    // const status = await Network.getStatus();
    // this.networkStatus = status.connected;

    // // Listen for network changes
    // Network.addListener('networkStatusChange', status => {
    //   this.networkStatus = status.connected;
    //   console.log('Network status changed:', status.connected, Network.getStatus());
    //   if(status.connected) {
    //     this.websocketActions.configure();
    //     MessageDisplayUtil.showMessageToast('Network connection restored', this.platform, this.toastCtl,
    //     3000, 'bottom')
    //   } else {
    //     MessageDisplayUtil.showErrorToast('Network connection lost', this.platform, this.toastCtl,
    //     3000, 'bottom')
    //   }
    // });

    // const requestDeleteAccount = Boolean(this.platform.getQueryParam('requestDelete'));

    // if (requestDeleteAccount && this.player$) {
    //   this.goClickAccountOption();
    // }
  }

  private handleNetworkChange(connected: boolean) {
    if (connected) {
      console.log('Network is available');
      // this.websocketActions.configure();
      if (global?.devMode && this.showMessageToast) {
        MessageDisplayUtil.showMessageToast(
          'Network connection is restored',
          this.platform,
          this.toastCtl,
          3000,
          'top'
        );
      }
      // Your logic when network becomes available
    } else {
      console.log('Network connection lost');
      // MessageDisplayUtil.showErrorToast(
      //   'Network connection lost',
      //   this.platform,
      //   this.toastCtl,
      //   5000,
      //   'top'
      // );
      // Your logic when network is lost
    }
  }

  async initCheckPermissions() {
    // Example: Request camera and storage permissions
    const permissions = [
      'android.permission.CAMERA',
      // 'android.permission.READ_MEDIA_IMAGES',
      // 'android.permission.READ_MEDIA_VIDEO',
      'android.permission.ACCESS_FINE_LOCATION',
      'android.permission.ACCESS_COARSE_LOCATION',
    ];

    const results = await this.permissionsService.checkMultiplePermissions(permissions);

    results.forEach((granted, permission) => {
      console.log(`Permission ${permission}: ${granted ? 'granted' : 'denied'}`);
    });

    // await Promise.all([
    //   this.permissionsService.checkCameraPermissionRequest(),
    //   this.permissionsService.checkLocationPermissionRequest(),
    //   this.permissionsService.checkMediaPermissionRequest()
    // ])
  }

  /**
   * Simulate a click at the center of the viewport
   */
  simulateCenterClick() {
    const viewportWidth = Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0
    );
    const viewportHeight = Math.max(
      document.documentElement.clientHeight || 0,
      window.innerHeight || 0
    );

    const centerX = Math.floor(viewportWidth / 2);
    const centerY = Math.floor(viewportHeight / 2);

    this.simulateClickAtPoint(centerX, centerY);
  }

  /**
   * Simulate a click at specific coordinates
   */
  simulateClickAtPoint(x: number, y: number) {
    // Create the click event
    const clickEvent = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true,
      clientX: x,
      clientY: y,
    });

    // Get element at point
    const element = document.elementFromPoint(x, y);

    if (element) {
      element.dispatchEvent(clickEvent);
    }
  }

  /**
   * Alternative method using Touch events for mobile
   */
  simulateTouchAtCenter() {
    const viewportWidth = Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0
    );
    const viewportHeight = Math.max(
      document.documentElement.clientHeight || 0,
      window.innerHeight || 0
    );

    const centerX = Math.floor(viewportWidth / 2);
    const centerY = Math.floor(viewportHeight / 2);

    const touchStart = new Touch({
      identifier: Date.now(),
      target: document.body,
      clientX: centerX,
      clientY: centerY,
      radiusX: 2.5,
      radiusY: 2.5,
      rotationAngle: 0,
      force: 1,
    });

    const touchStartEvent = new TouchEvent('touchstart', {
      cancelable: true,
      bubbles: true,
      touches: [touchStart],
      targetTouches: [touchStart],
      changedTouches: [touchStart],
    });

    const touchEndEvent = new TouchEvent('touchend', {
      cancelable: true,
      bubbles: true,
      touches: [],
      targetTouches: [],
      changedTouches: [touchStart],
    });

    const element = document.elementFromPoint(centerX, centerY);
    if (element) {
      element.dispatchEvent(touchStartEvent);
      setTimeout(() => {
        element.dispatchEvent(touchEndEvent);
      }, 50);
    }
  }

  private setupConnectionHandlers() {
    // // Handle app going to background/foreground
    this.platform.resume.subscribe(() => {
      console.log('App resumed, reconnecting WebSocket');
      this.playerHomeActions.initWebsocketActions();
      // this.websocketActions.configure();
      // MessageDisplayUtil.showMessageToast('App resumed', this.platform, this.toastCtl,
      // 3000, 'top')
    });

    // Handle online/offline status
    window.addEventListener('online', () => {
      console.log('Network connection restored, reconnecting WebSocket');
      this.playerHomeActions.initWebsocketActions();
      this.websocketActions.configure();
      // MessageDisplayUtil.showMessageToast(
      //   'Network connection restored',
      //   this.platform,
      //   this.toastCtl,
      //   3000,
      //   'top'
      // );
    });

    window.addEventListener('offline', () => {
      console.log('Network connection lost');
      // MessageDisplayUtil.showErrorToast(
      //   'Network connection lost',
      //   this.platform,
      //   this.toastCtl,
      //   3000,
      //   'top'
      // );
      // this.connectionStatus.next(false);
    });
  }

  setupWebOneSignal() {
    // if (1) return;
    // // Wait for the OneSignal script to load
    // window.addEventListener('load', () => {
    //   if (typeof OneSignal !== 'undefined') {
    //     OneSignal.init({
    //       appId: '8a23eb44-fcac-4899-a4e4-2ce8fbd9851a',
    //       allowLocalhostAsSecureOrigin: true,
    //     });
    //   }
    // });
  }

  private async setupSafeArea() {
    try {
      const { insets } = await SafeArea.getSafeAreaInsets();
      this.applyInsets(insets);

      await SafeArea.addListener('safeAreaChanged', ({ insets }) => {
        this.applyInsets(insets);
      });
    } catch (err) {
      console.warn('SafeArea plugin not available', err);
    }
  }

  private applyInsets(insets: { top: number; right: number; bottom: number; left: number }) {
    const root = document.documentElement;
    root.style.setProperty('--safe-area-inset-top', `${insets.top}px`);
    root.style.setProperty('--safe-area-inset-right', `${insets.right}px`);
    root.style.setProperty('--safe-area-inset-bottom', `${insets.bottom}px`);
    root.style.setProperty('--safe-area-inset-left', `${insets.left}px`);
  }

  messaging: any = null; // Firebase Web SDK disabled
  async initWebFirebase() {
    // Firebase Web SDK disabled for iOS compatibility
    console.log('Firebase Web SDK disabled - using native push notifications only');
    return;

    // Original code commented out:
    // try {
    //   let firebaseConfig = environment.firebaseConfig;
    //   const token = await getToken(messaging, {
    //     vapidKey: firebaseConfig.vapidKey,
    //   });
    //   this.flightService.notfRegisterToken(token, 'player-web').subscribe(
    //     data => {
    //       console.debug('success fcm token register : ', data);
    //     },
    //     error => {
    //       console.debug('error fcm : ', JSON.stringify(error));
    //     }
    //   );
    //   console.log('Web FCM Token:', token);
    //   // ... rest of Firebase code
    // } catch (err) {
    //   console.error('Error getting FCM token:', err);
    // }
  }

  routerSub: Subscription;
  private initializeBackButton() {
    this.backButtonSubscription = this.platform.backButton.subscribeWithPriority(10000, () => {
      this.handleBackButton();
    });

    // this.routerSub = this.router.events.subscribe(async event => {
    //   if (event instanceof NavigationStart && event.navigationTrigger === 'popstate') {
    //     const topModal = await this.modalCtl.getTop();
    //     if (topModal) {
    //       // 🔒 Stop browser back navigation
    //       await topModal.dismiss();

    //       // Restore current URL so history doesn't move
    //       // history.pushState(null, '', this.router.url);

    //       // 🚫 Cancel browser back navigation
    //       this.router.navigateByUrl(this.router.url, {
    //         replaceUrl: false,
    //       });
    //     } else {
    //       // this.Location.back();
    //       window.history.back();
    //     }
    //   }
    // });

    // window.onpopstate = async () => {
    //   this.handleBackButton();
    // };
  }

  private async handleBackButton() {
    const topModal = await this.modalCtl.getTop();

    if (topModal) {
      // 🔒 Consume back action entirely
      await topModal.dismiss();
      return;
    } else {
      window.history.back();
      // this.Location.back();
    }

    // ❗ No modal → allow navigation or exit logic
    // Example:
    // if (this.router.url === '/home') {
    //   this.showExitConfirmation();
    // } else {
    //   this.location.back();
    // }
  }

  async initiateCapUpdater() {
    const mainAppAttributes = this.mg2uUtil
      .getSpecificAppAttributePage('mainApp')
      ?.appUpdates?.find(app => {
        if (global.appType === 'main') {
          return app?.tenant === 'main';
        } else {
          return app?.tenant === global.appClient?.toLowerCase();
        }
      });
    const tenant = mainAppAttributes?.tenant?.toLowerCase();
    const updateVersion = mainAppAttributes?.updateVersion;
    const platform = this.platform.is('android') ? 'android' : 'ios';
    const isMandatory = mainAppAttributes?.mandatory || false;
    let appEnvironment = global.MygolfServerHost?.split('let.')[0];
    if (appEnvironment === 'prd') appEnvironment = 'prod';
    const env = appEnvironment; //global?.appEnvironment ||
    let data = { id: updateVersion };

    const downloadUrl = `https://prdupdates.mygolf2u.com/bundles/${tenant}/${env}/mygolf2u-${tenant}-${updateVersion}-${platform}.zip`;

    // DIAGNOSTIC: Log URL being used
    console.log('[app.component] initiateCapUpdater() called');
    console.log('[app.component] Download URL:', downloadUrl);
    console.log('[app.component] URL pattern: Direct static path (NOT using token-based API)');
    console.log(
      '[app.component] Expected API pattern: /api/v1/bundles/download/{app_type}/{environment}?version=X.X.X&token=<jwt>'
    );
    console.log('[app.component] LiveUpdateService available:', !!this.liveUpdateService);

    // Check current bundle info before download
    const currentBundle = await CapacitorUpdater.current();
    console.log('[app.component] Current bundle before download:', currentBundle);

    // List available versions before download
    const listBefore = await CapacitorUpdater.list();
    console.log('[app.component] Available versions before download:', listBefore);

    // DIAGNOSTIC: Test if the URL is accessible before attempting download
    this.testDownloadUrlAccessibility(downloadUrl);

    CapacitorUpdater.notifyAppReady();
    const updaterHandle = CapacitorApp.addListener('appStateChange', async state => {
      if (!isMandatory) {
        // (await updaterHandle).remove();
        return;
      }
      if (state.isActive) {
        // ========================================
        // NEW: Interval Check for Non-Mandatory Updates
        // ========================================
        if (!isMandatory) {
          // Get check interval from appProperties
          const checkInterval = (global as any).updateConfig?.checkInterval || 60 * 60 * 1000; // Default: 1 hour

          // Get last check timestamp from preference (async operation)
          const lastCheckTimestamp$ = this.mg2uUtil.getPref(this.UPDATE_LAST_CHECK_KEY);
          const lastCheckTimestamp = await lastCheckTimestamp$.pipe(take(1)).toPromise();
          const now = Date.now();

          if (lastCheckTimestamp) {
            const timeSinceLastCheck = now - parseInt(lastCheckTimestamp as string, 10);
            if (timeSinceLastCheck < checkInterval) {
              console.log(
                '[app.component] Update check throttled. Last checked:',
                new Date(parseInt(lastCheckTimestamp as string, 10)).toISOString()
              );
              console.log(
                '[app.component] Time since last check:',
                Math.floor(timeSinceLastCheck / 1000 / 60),
                'minutes'
              );
              console.log(
                '[app.component] Check interval:',
                Math.floor(checkInterval / 1000 / 60),
                'minutes'
              );
              return;
            }
          }

          // Update last check timestamp
          this.mg2uUtil.setPref(this.UPDATE_LAST_CHECK_KEY, now.toString());
        }

        // ========================================
        // NEW: Get Local Version for Comparison
        // ========================================
        const localVersion$ = this.mg2uUtil.getPref(this.UPDATE_LAST_VERSION_KEY);
        const localVersion = await localVersion$.pipe(take(1)).toPromise();
        let currentVersion: string;

        if (localVersion) {
          // Use local stored version if available
          currentVersion = localVersion as string;
          console.log('[app.component] Using local version for comparison:', currentVersion);
        } else {
          // Fall back to bundle/base version if no local version
          const bundleCurrentVersion = currentBundle.bundle.version;
          const baseVersion = mainAppAttributes?.baseVersion;

          if (bundleCurrentVersion === 'builtin' || bundleCurrentVersion === 'main') {
            currentVersion = baseVersion;
          } else {
            currentVersion = bundleCurrentVersion;
          }
          console.log(
            '[app.component] No local version found, using bundle/base version:',
            currentVersion
          );
        }

        // ========================================
        // NEW: Compare Versions Before Downloading
        // ========================================
        console.log('[app.component] Version comparison:', {
          current: currentVersion,
          update: updateVersion,
          // needsUpdate: updateVersion > currentVersion,
          needsUpdate: this.isUpdateAvailable(currentVersion, updateVersion),
        });

        // Only download if updateVersion is greater than currentVersion
        // if (updateVersion <= currentVersion) {
        if (!this.isUpdateAvailable(currentVersion, updateVersion)) {
          console.log(
            '[app.component] Already on version',
            updateVersion,
            'or newer. Skipping update.'
          );
          return;
        }

        // Do the download during user active app time to prevent failed download
        console.log('[app.component] Starting CapacitorUpdater.download()...');
        console.log('[app.component] Download params:', { version: data?.id, url: downloadUrl });
        console.log(
          '[app.component] Platform info:',
          await this.platform.ready().then(() => this.platform.platforms())
        );

        try {
          console.log('[app.component] About to call CapacitorUpdater.download()...');
          console.log('[app.component] Download URL:', downloadUrl);
          console.log('[app.component] Version:', data?.id);

          data = await CapacitorUpdater.download({
            version: updateVersion,
            url: downloadUrl, //'https://github.com/Cap-go/demo-app/releases/download/0.0.4/dist.zip',
          });

          console.log('[app.component] Download SUCCESS:', data);

          // List available versions after download
          const listAfter = await CapacitorUpdater.list();
          console.log('[app.component] Available versions after download:', listAfter);

          // Check the downloaded bundle info
          console.log('[app.component] Downloaded bundle info:', data);

          // Use currentVersion for comparison instead of bundle.version
          // if (compare(currentVersion < updateVersion)) {
          //   await this.onPromptUpdate(currentVersion, updateVersion, data, isMandatory);
          // }
          if (this.isUpdateAvailable(currentVersion, updateVersion)) {
            await this.onPromptUpdate(currentVersion, updateVersion, data, isMandatory);
          }
        } catch (downloadError) {
          console.error('[app.component] Download FAILED with error:');
          console.error('[app.component] Error name:', downloadError?.name);
          console.error('[app.component] Error message:', downloadError?.message);
          console.error('[app.component] Full error:', JSON.stringify(downloadError));
          console.error('[app.component] Error stack:', downloadError?.stack);

          // Try to get more info about what went wrong
          try {
            const currentBundle = await CapacitorUpdater.current();
            console.error('[app.component] Current bundle after failed download:', currentBundle);
          } catch (e) {
            console.error('[app.component] Could not get current bundle after error:', e);
          }
        }
      }
      console.error('[app.component] state and data:', state, data);
      if (
        !state.isActive &&
        data.id !== '' &&
        isMandatory &&
        currentBundle.bundle.version !== updateVersion
      ) {
        console.error('[app.component] [1] state and data:', state, data);
        this.goAppUpdate(data, updateVersion);
        // // Do the switch when user leave app
        // splashScreen.show();
        // try {
        //   await CapacitorUpdater.set(data);
        // } catch (err) {
        //   console.log(err);
        //   splashScreen.hide(); // in case the set fail, otherwise the new app will have to hide it
        // }
      }
    });
  }

  /**
   * Diagnostic method to test if download URL is accessible
   */
  private async testDownloadUrlAccessibility(url: string): Promise<void> {
    console.log('[app.component] === Testing Download URL Accessibility ===');
    console.log('[app.component] URL to test:', url);

    // Test with native fetch (works in web/debug mode)
    try {
      console.log('[app.component] Testing with fetch HEAD request...');
      const headResponse = await fetch(url, {
        method: 'HEAD',
        cache: 'no-store',
      });
      console.log('[app.component] HEAD response status:', headResponse.status);
      console.log('[app.component] HEAD response ok:', headResponse.ok);
      console.log(
        '[app.component] HEAD headers:',
        Object.fromEntries(headResponse.headers.entries())
      );

      // Check content type and size
      const contentType = headResponse.headers.get('content-type');
      const contentLength = headResponse.headers.get('content-length');
      console.log('[app.component] Content-Type:', contentType);
      console.log('[app.component] Content-Length:', contentLength, 'bytes');

      // Verify it's a ZIP file
      if (contentType && !contentType.includes('zip') && !contentType.includes('octet-stream')) {
        console.warn(
          '[app.component] WARNING: Content-Type is not zip or octet-stream:',
          contentType
        );
      }

      // Verify file size is reasonable (should be > 1MB for a full app bundle)
      if (contentLength) {
        const sizeMB = parseInt(contentLength) / (1024 * 1024);
        console.log('[app.component] File size:', sizeMB.toFixed(2), 'MB');
        if (sizeMB < 0.5) {
          console.warn(
            '[app.component] WARNING: File size seems too small for a full app bundle : ',
            sizeMB,
            contentLength
          );
        }
      }
    } catch (fetchError) {
      console.error('[app.component] Fetch HEAD test failed:', fetchError);
    }

    // Test with CapacitorHttp (works on mobile)
    try {
      console.log('[app.component] Testing with CapacitorHttp HEAD request...');
      const capResponse = await CapacitorHttp.get({
        url,
        headers: { 'User-Agent': 'myGolf2u/5.0.0' },
      });
      console.log('[app.component] CapacitorHttp response status:', capResponse.status);
      console.log(
        '[app.component] CapacitorHttp response data length:',
        capResponse.data?.length || 0
      );
    } catch (capError) {
      console.error('[app.component] CapacitorHttp test failed:', capError);
    }

    console.log('[app.component] === End URL Accessibility Test ===');
  }
  showMessageToast = false;
  handleAllowedMessageDisplay() {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(async (event: NavigationEnd) => {
        // Add all routes where tabs should be hidden
        const allowedMessageDisplayRoutes = [
          'gameround-scoring',
          'scramble-scoring',
          'matchplay-scoring',
          'scorecard-display',
          'scramble-display',
        ];
        const _len = event.url.split('/')?.length - 1;
        const _url = event.url.split('/')[_len];
        // event.url.split('/')[_len];
        this.showMessageToast = allowedMessageDisplayRoutes.includes(_url);
      });
  }

  async onPromptUpdate(
    currentVersion: string,
    updateVersion: string,
    data: any,
    mustUpdate: boolean = false
  ) {
    if (mustUpdate) {
      const content = `There is new update version ${updateVersion}. This will restart the app`;
      const _message = {
        title: 'New Version Required',
        content,
      };

      const modal = await this.modalCtl.create({
        mode: 'ios',
        component: CommonPullupMenuComponent,
        cssClass: 'self-adjustable-modal',
        componentProps: {
          app: null,
          message: _message,
          mode: 'infoDisplay',
          closeBtnText: 'OK',
        },
      });
      await modal.present().then(() => {
        const height = this.platform.height() - 250;
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
      });
      modal.onDidDismiss().then((dismissData: any) => {
        this.goAppUpdate(data, updateVersion);
      });
    } else {
      const title = 'New Version Available';
      const content = `There is new update version : ${updateVersion}.
      You are on version ${currentVersion}.
      Updating will restart the app. Do you want to update now?`;

      const modal = await this.modalCtl.create({
        mode: 'ios',
        component: CommonPullupMenuComponent,
        cssClass: 'self-adjustable-modal',
        componentProps: {
          mode: 'negative-confirmation',
          headerTitle: title,
          confirmMessage: content,
        },
      });
      await modal.present().then(() => {
        const height = this.platform.height() - 250;
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
      });
      modal.onDidDismiss().then((dismissData: any) => {
        if (dismissData?.data) {
          this.goAppUpdate(data, updateVersion);
        }
      });
    }
  }

  async goAppUpdate(data, updateVersion?: string) {
    // Do the switch when user leave app
    // splashScreen.show();

    const _splashScreen = document.getElementById('custom-splash-screen');
    try {
      await CapacitorUpdater.set(data);
      // await this.liveUpdateService.cleanupOldBundles();

      // ========================================
      // NEW: Store the successfully applied version
      // ========================================
      if (updateVersion) {
        this.mg2uUtil.setPref(this.UPDATE_LAST_VERSION_KEY, updateVersion);
        console.log('[app.component] Successfully applied update version:', updateVersion);
        console.log('[app.component] Stored in local preferences for future comparison');
      }
    } catch (err) {
      console.log(err);
      setTimeout(() => {
        if (_splashScreen) {
          _splashScreen.style.display = 'none';
        }
      }, this.spinnerLoaderDelay);
      // splashScreen.hide(); // in case the set fail, otherwise the new app will have to hide it
    }
  }
  private isUpdateAvailable(currentVersion: string, updateVersion: string): boolean {
    const current = currentVersion.split('.').map(Number);
    const update = updateVersion.split('.').map(Number);

    for (let i = 0; i < Math.max(current.length, update.length); i++) {
      const currentPart = current[i] || 0;
      const updatePart = update[i] || 0;

      if (currentPart < updatePart) return true;
      if (currentPart > updatePart) return false;
    }

    return false; // versions are equal
  }

  async goClickAccountOption() {
    let modal = await this.modalCtl.create({
      component: AccountOptionPage,
      componentProps: {
        player: this.player$,
        friend: false,
      },
    });
    modal.onDidDismiss().then((data: any) => {
      if (data && data?.data?.needRefresh) {
        this.playerHomeActions.setNeedRefresh(true);
      }
    });
    modal.present();
  }
}
